import { FieldText, FieldTextProps } from '@dixa/lib-shared-habla';
import { ChangeEvent, useCallback } from 'react';

type Props = {
  value: string;
  onChange: (title: string) => void;
  errorCode?: TitleError | null;
} & Omit<FieldTextProps, 'label' | 'placeholder' | 'input'>;

export const MISSING_TITLE_ERROR = 'Please add a name to this file';

export enum TitleError {
  MissingTitle,
}

export const ErrorMap = {
  [TitleError.MissingTitle]: MISSING_TITLE_ERROR,
};

export function TitleInput({
  value,
  errorCode,
  onChange: onChangeCallback,
  ...otherProps
}: Props): JSX.Element {
  const error = ErrorMap[errorCode ?? ''];
  const onChange = useCallback(
    (event?: ChangeEvent<HTMLInputElement>) => {
      if (!event) {
        return;
      }

      const {
        target: { value },
      } = event;

      onChangeCallback(value);
    },
    [onChangeCallback],
  );

  return (
    <FieldText
      {...otherProps}
      label="Title"
      placeholder="E.g. Welcome announcement"
      input={{ name: 'title', value, onChange }}
      meta={{ error }}
    />
  );
}
